import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { currency } from "@/lib/format";

export default function BillSummary({ bill, tipAmount, total }) {
    return (
        <Card>
            <CardContent className="p-6">
                <h2 className="font-display text-xl mb-3">Itemized bill</h2>
                <div className="space-y-1.5 text-sm">
                    {bill.line_items.map((li, index) => (
                        <div key={`${li.name}-${index}`} className="flex items-center justify-between">
                            <div>
                                {li.quantity}× {li.name}
                            </div>
                            <div>{currency(li.line_total)}</div>
                        </div>
                    ))}
                </div>
                <Separator className="my-4" />
                <div className="text-sm space-y-1">
                    <Row label="Subtotal" value={currency(bill.subtotal)} />
                    <Row label={`Tax (${(bill.tax_rate * 100).toFixed(1)}%)`} value={currency(bill.tax)} />
                    <Row label="Tip" value={currency(tipAmount)} />
                    <div className="flex justify-between font-semibold text-base pt-2">
                        <span>Total</span>
                        <span data-testid="bill-total-amount">{currency(total)}</span>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}

function Row({ label, value }) {
    return (
        <div className="flex justify-between">
            <span className="text-muted-foreground">{label}</span>
            <span>{value}</span>
        </div>
    );
}
